import React from "react";
import "./Certifications.css";
import certifications from "../data/certifications.json";

const Certifications = () => {
  return (
    <section id="certifications">
      <h1 id="certifications-header">Certifications</h1>

      <div className="certifications-section">
        {certifications.map((cert, index) => (
          <div className="cert-card" key={index}>
            <div className="cert-header">
              <img src={cert.image} alt={cert.title} className="cert-image" />
              <h3 className="cert-title">{cert.title}</h3>
            </div>
            <span className="cert-year">{cert.year}</span>
            <p className="cert-description">{cert.description}</p>

            <div className="cert-tags">
              {cert.tags.map((tag, i) => (
                <span className="cert-tag" key={i}>
                  {tag}
                </span>
              ))}
            </div>

            {cert.certificateUrl && (
              <a
                href={cert.certificateUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cert-button"
              >
                View Certificate
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
